// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5601":"cb89c46e","9627":"cb89c46e"}[chunkId] + ".chunk.css";
};